import { add, isBefore, sub } from 'date-fns';
import { addonMappingV2, addonMappingCabin, AddonMappingReturnV2 } from './addonMapping';
import { checkRuleEnabled } from './checkRuleEnabled';
import { camelKeyToSnakeCase } from './extractFareRule';

export const extractRefundAndUpdate = ({
  airline, fareClass, expireDate, expireTime, fareRules, cabin = '', isTetDay,
  fareConfig,
}: { airline: string, fareClass: string, expireDate: string, expireTime: string, fareConfig: AddonMappingReturnV2[], fareRules?: any, cabin: string, isTetDay?: boolean }) => {
  const CONFIG = addonMappingV2({
    airlineCode: airline,
    classCode: fareClass,
    fareConfig,
    fareRules: null,
    isTetDay,
    cabin,
  }) as any;

  if (!CONFIG) {
    return {};
  }

  const timeFrame1 = {
    isRefund: checkRuleEnabled(CONFIG.is_refund_1),
    timeFromRefund: +CONFIG.time_from_refund_1 || +CONFIG.time_from_refund || 0,
    timeFromUpdate: +CONFIG.time_from_update_1 || +CONFIG.time_from_update || 0,
    reasonRefund: CONFIG.reason_refund_1,
    refundFee: CONFIG.refund_fee_1,
    isUpdateTicket: checkRuleEnabled(CONFIG.is_update_ticket_1),
    updateFee: CONFIG.update_fee_1,
  };

  const timeFrame2 = {
    isRefund: checkRuleEnabled(CONFIG.is_refund_2),
    reasonRefund: CONFIG.reason_refund_2,
    refundFee: CONFIG.refund_fee_2,
    isUpdateTicket: checkRuleEnabled(CONFIG.is_update_ticket_2),
    updateFee: CONFIG.update_fee_2,
    timeFromUpdate: +CONFIG.time_from_update_2,
    timeFromRefund: +CONFIG.time_from_refund_2,
  };

  const timeFrame3 = {
    isRefund: checkRuleEnabled(CONFIG.is_refund_3),
    reasonRefund: CONFIG.reason_refund_3,
    refundFee: CONFIG.refund_fee_3,
    isUpdateTicket: checkRuleEnabled(CONFIG.is_update_ticket_3),
    updateFee: CONFIG.update_fee_3,
    timeFromUpdate: +CONFIG.time_from_update_3,
    timeFromRefund: +CONFIG.time_from_refund_3,
  };

  const dateTime = expireDate
    && add(new Date(expireDate as any), {
      hours: +(expireTime as any).split(':')[0],
      minutes: +(expireTime as any).split(':')[1],
    });

  const refundExpireDateTime1 = !!dateTime
  && sub(new Date(dateTime), { hours: +timeFrame1.timeFromRefund });
  const refundExpireDateTime2 = !!dateTime
  && sub(new Date(dateTime), { hours: +timeFrame2.timeFromRefund });
  const refundExpireDateTime3 = !!dateTime
  && sub(new Date(dateTime), { hours: +timeFrame3.timeFromRefund });
  const canRefund1 = isBefore(new Date(), new Date(refundExpireDateTime1 as any));
  const canRefund2 = isBefore(new Date(), new Date(refundExpireDateTime2 as any));
  const canRefund3 = isBefore(new Date(), new Date(refundExpireDateTime3 as any));
  const canRefund = canRefund1 || canRefund2 || canRefund3;
  const canSupportRefund2 = timeFrame2.isRefund;
  const canSupportRefund1 = timeFrame1.isRefund;
  const canSupportRefund3 = timeFrame3.isRefund;
  const canSupportRefund = canSupportRefund1 || canSupportRefund2 || canSupportRefund3;

  const updateExpireDateTime1 = !!dateTime && sub(new Date(dateTime), { hours: +timeFrame1.timeFromUpdate });
  const updateExpireDateTime2 = !!dateTime && sub(new Date(dateTime), { hours: +timeFrame2.timeFromUpdate });
  const updateExpireDateTime3 = !!dateTime && sub(new Date(dateTime), { hours: +timeFrame3.timeFromUpdate });
  const canUpdate1 = isBefore(new Date(), new Date(updateExpireDateTime1 as any));
  const canUpdate2 = isBefore(new Date(), new Date(updateExpireDateTime2 as any));
  const canUpdate3 = isBefore(new Date(), new Date(updateExpireDateTime3 as any));
  const canUpdate = canUpdate1 || canUpdate2 || canUpdate3;
  const canSupportUpdate1 = timeFrame1.isUpdateTicket;
  const canSupportUpdate2 = timeFrame2.isUpdateTicket;
  const canSupportUpdate3 = timeFrame3.isUpdateTicket;
  const canSupportUpdate = canSupportUpdate1 || canSupportUpdate2 || canSupportUpdate3;

  return {
    canRefund1,
    canRefund2,
    canRefund3,
    canRefund,
    canSupportRefund1,
    canSupportRefund2,
    canSupportRefund3,
    canSupportRefund,
    timeFrame1,
    timeFrame2,
    timeFrame3,
    refundExpireDateTime1,
    refundExpireDateTime2,
    refundExpireDateTime3,
    canUpdate1,
    canUpdate2,
    canUpdate3,
    canUpdate,
    canSupportUpdate1,
    canSupportUpdate2,
    canSupportUpdate3,
    canSupportUpdate,
    updateExpireDateTime1,
    updateExpireDateTime2,
    updateExpireDateTime3,
    detailVi: CONFIG.detail_vi,
    seatClass: CONFIG.seat_class,
    refundMethod: CONFIG.refund_method,
  };
};
